<template>
    <div class="apprentice-simple-card administrator-management">
        <div class="row">
            <div class="col-12">
                <design-2021-statistics-index-overall-statistics-component
                    :number-of-groups-in="numberOfGroupsIn"
                    :number-of-teachers-in="numberOfTeachersIn"
                    :number-of-students-in="numberOfStudentsIn">
                </design-2021-statistics-index-overall-statistics-component>

            </div>
        </div>

        <div class="row">
            <div class="col-12 col-md-6 d-flex align-items-stretch">
                <div class="card login-statistics remove-box-shadow">
                    <div class="card-header">
                        Login
                    </div>
                    <div class="card-body">
                        <design-2021-statistics-index-login-component
                            :student-numbers-in="studentNumbers"
                            :student-labels-in="studentLabels"
                            :teacher-numbers-in="teacherNumbers"
                        ></design-2021-statistics-index-login-component>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6 d-flex align-items-stretch ">
                <div class="card editor-statistics remove-box-shadow">
                    <div class="card-header">
                        Editors
                    </div>
                    <div class="card-body">
                        <design-2021-statistics-index-editors-component
                            :editors-in="editorsIn"
                        ></design-2021-statistics-index-editors-component>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-md-6 d-flex align-items-stretch">
                <div class="card timeline-statistics remove-box-shadow">
                    <div class="card-header">
                        {{$t('statistics.timeline')}}
                    </div>
                    <div class="card-body">
                        <design-2021-statistics-index-timeline-component
                            :profiles-numbers-in="profileNumbers"
                            :profiles-labels-in="profileLabels"
                        ></design-2021-statistics-index-timeline-component>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6 d-flex align-items-stretch">
                <div class="card assignments-statistics remove-box-shadow">
                    <div class="card-header">
                        {{$t('statistics.portfolio_activity_by_group')}}
                    </div>
                    <div class="card-body">
                        <design-2021-statistics-index-assignments-component
                            :assignment-datas-in="assignmentData"
                            :assignment-labels-in="assignmentLabels"
                        ></design-2021-statistics-index-assignments-component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Design2021StatisticsIndexOverallStatisticsComponent
    from "./design-2021-statistics-index-overall-statistics-component.vue";
import Design2021StatisticsIndexLoginComponent from "./design-2021-statistics-index-login-component.vue";
import Design2021StatisticsIndexEditorsComponent from "./design-2021-statistics-index-editors-component.vue";
import Design2021StatisticsIndexTimelineComponent from "./design-2021-statistics-index-timeline-component.vue";
import Design2021StatisticsIndexAssignmentsComponent from "./design-2021-statistics-index-assignments-component.vue";
export default {
    name: "design-2021-statistics-index-component",
    components: {
        Design2021StatisticsIndexAssignmentsComponent,
        Design2021StatisticsIndexTimelineComponent,
        Design2021StatisticsIndexEditorsComponent,
        Design2021StatisticsIndexLoginComponent, Design2021StatisticsIndexOverallStatisticsComponent},
    props: [
        'schoolIn',
        'numberOfGroupsIn',
        'numberOfTeachersIn',
        'numberOfStudentsIn',
        'studentLoginsIn',
        'teacherLoginsIn',
        'profilesIn',
        'editorsIn',
        'assignmentAnswersIn'
    ],
    data(){
        return{
            assignmentData:    this.assignmentAnswersIn['groupsData'],
            assignmentLabels:  this.assignmentAnswersIn['labels'],
            studentNumbers:    this.studentLoginsIn['data'],
            studentLabels:     this.studentLoginsIn['labels'],
            teacherNumbers:    this.teacherLoginsIn['data'],
            profileNumbers:    this.profilesIn['data'],
            profileLabels:     this.profilesIn['labels']
        }
    }
}
</script>

<style scoped>

    .login-statistics,
    .editor-statistics,
    .timeline-statistics,
    .assignments-statistics {
        margin-bottom: 30px;
        flex: 1;
        border: 1px solid #E8EFF4
    }

    .card-header{
        padding: 15px;
        font-size: 1.125rem;
        font-weight: 500;
    }

    .card-body {
        padding: 15px;
    }

</style>
